import uniqid from 'uniqid';
import spezies from './Kennzeichnung/Spezies';
import {
  Standard as StandardDataField,
  Ringtyp as RingtypDataField
} from "./Kennzeichnung/StandardDataFields";
import CreatureConfigFields from "./CreatureConfigFields";
import CreatureKennzeichnungAnpassenEntity from './CreatureKennzeichnungAnpassen';

export const role_parent = "parent";
export const role_child = "child";
export const role_standard = "standard";

const Creature = (config=CreatureConfigFields()) => {

    const check = (value) => {
      if (!config.hasOwnProperty(value)) {
        return false
      }
      return config[value];
    }

    let cre = {
      type:"creature",
      role:role_standard,
      uniqueId: uniqid.time(),
      istParent: false,
      zeigeAnzahl: true,
      kennzeichnungAnpassen:CreatureKennzeichnungAnpassenEntity(),
      anzahl: 1,
      parents: [],
      children: {},
      zoomIn: { 
        value:true,
      },
    }

    if (check('spezies')) {
      cre.spezies = spezies()
    }

    if (check('geschlecht')) {
      cre.geschlecht = StandardDataField()
    }

    if (check('rufname')) {
      cre.rufname = StandardDataField()
    }
    
    if (check('meldeid')) {
      cre.meldeid = {
        value: "",
        valide: null,
      }
    }

    if (check('geburtsdatum')) {
      cre.geburtsdatum = {
        value: null, // ISO Date
        valide: null,
      }

      cre.geburtsdatumZusatz = {
        value: 'aufTagGenau',
        valide: null,
      }
    }
    
    if (check('datumBesitzSeit')) {
      cre.datumBesitzSeit = {
        value: null, // ISO Date
        valide: null,
      }
    }

    if (check('mengenmeldung')) {
      cre.genderMale = StandardDataField()
      cre.genderFemale = StandardDataField()
      cre.genderUnknown = StandardDataField()
    }
    
    if (check('ring')) {
      cre.ringtyp = RingtypDataField()

      cre.ringnummer = StandardDataField()
    }
    
    if (check('microchip')) {
      cre.microchip = {
        value: '',
        valide: null,
      }
    }
    
    if (check('andereKennzeichnung')) {
      cre.andereKennzeichnungArt = {
        value: '',
        valide: null,
      }

      cre.andereKennzeichnungBeschreibung = {
        value: '',
        valide: null,
      }
    }
    
    if (check('zuchtbuch')) {
      cre.zuchtbuchNummerDesBuches = {
        value: '',
        valide: null,
      }

      cre.zuchtbuchNummerDesTieres = {
        value: '',
        valide: null,
      }
    }
    
    if (check('rufname')) {
      cre.rufname = {
        value: '',
        valide: null,
      }
    }
    
    if (check('fotodokumentation')) {
      cre.fotodokumentation = {}
    }
    
    if (check('dokumente')) {
      cre.dokumente = {}
    }

    if (check('gewicht')) {
      cre.gewicht = {
        value: '',
        valide: null,
      }
    }

    if (check('groesse')) {
      cre.groesse = {
        value: '',
        valide: null,
      }
    }

    return cre;
    
}

export default Creature;